export const SUCCESS = 'success';
export const FAILED = 'failed';

export const isFailed = (task) => !!task && task.status === FAILED;

export const getCurrentTask = (state) => state.taskState.currentTask;
